class ProductForm extends HTMLElement {
  constructor() {
    super();   

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector('cart-notification');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    this.cartNotification.setActiveElement(document.activeElement);
    
    const submitButton = this.querySelector('[type="submit"]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
      sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        this.cartNotification.renderContents(parsedState);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
      });
  }
}
customElements.define('product-form', ProductForm);
$(document).ready(function(){
  var $main = $('.slider-mobile-gutter:not([data-count="1"]) .product__media-list');
  var $thumb = $('.slider-mobile-gutter:not([data-count="1"]) .prod-thumbnail-slider');
  var $counter = $('.prod-media-count');
  $main.on('init', function(event, slick){
    var totalSlides = slick.slideCount;
    $counter.text('1 / ' + totalSlides); 
  });
  $main.slick({
    slidesToShow: 1.8,
    slidesToScroll: 1,
    arrows: false,
    infinite: false,
    speed: 400,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
  $thumb.slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    variableWidth: true,
    infinite: false
  });
  $thumb.find('[data-slick-index="0"]').addClass('is-active');
  $main.on('afterChange', function(event, slick, currentSlide){
    var totalSlides = slick.slideCount;
    $thumb.find('.slick-slide').removeClass('is-active');
    $thumb.find('[data-slick-index="'+currentSlide+'"]').addClass('is-active');
    $counter.text((currentSlide + 1) + ' / ' + totalSlides);
  });
  $thumb.on('click', '.slick-slide', function(){
    var index = $(this).data('slick-index');
    $main.slick('slickGoTo', index);
  });
});
// document.addEventListener("DOMContentLoaded", function () {
//   const addToCart = document.querySelector(".product-form");
//   const footer = document.querySelector("#shopify-section-footer");

//   if (!addToCart || !footer) return;

//   function checkVisibility() {
//     const rect = addToCart.getBoundingClientRect();
//     const footerRect = footer.getBoundingClientRect();

//     const isInViewport =
//       rect.top < window.innerHeight && rect.bottom > 0;

//     const isFooterVisible =
//       footerRect.top < window.innerHeight;

//     if (!isInViewport && !isFooterVisible) {
//       document.body.classList.add("stickybar");
//     } else {
//       document.body.classList.remove("stickybar");
//     }
//   }

//   // ✅ Run once on load (important for mobile)
//   checkVisibility();

//   window.addEventListener("scroll", checkVisibility);
//   window.addEventListener("resize", checkVisibility);
// });


document.addEventListener("DOMContentLoaded", function () {
  const addToCart = document.querySelector("product-form");
  const footer = document.querySelector("#shopify-section-footer");
  const header = document.querySelector("#shopify-section-header");
  const announcement = document.querySelector("#shopify-section-announcement-bar");
  const stickyBtn = document.querySelector(".sticky-btn");

  if (!addToCart || !footer) return;

  function getHeaderHeight() {
    let height = 0;

    if (header) {
      const headerRect = header.getBoundingClientRect();
      if (headerRect.bottom > 0) {
        height += headerRect.height;
      }
    }

    if (announcement) {
      const annRect = announcement.getBoundingClientRect();
      if (annRect.bottom > 0) {
        height += annRect.height;
      }
    }

    return height;
  }

  
function checkPosition() {
    const rect = addToCart.getBoundingClientRect();
  const footerRect = footer.getBoundingClientRect();
  const headerHeight = getHeaderHeight();

  const isOutOfView =
    rect.top > window.innerHeight || rect.bottom <= headerHeight;

  const isFooterVisible = footerRect.top < window.innerHeight;

  if (isOutOfView && !isFooterVisible) {
    document.body.classList.add("stickybar");
  } else {
    document.body.classList.remove("stickybar");
  }
}


  if (stickyBtn) {
    stickyBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      const headerHeight = getHeaderHeight();

      const rect = addToCart.getBoundingClientRect();
      const elementTop = rect.top + window.scrollY;
      const elementHeight = rect.height;

      const targetScroll =
        elementTop -
        (window.innerHeight / 2) +
        (elementHeight / 2);

      window.scrollTo({
        top: targetScroll,
        behavior: "smooth",
      });
    });
  }


  setTimeout(function() {
      checkPosition();
    window.addEventListener("scroll", checkPosition);
    window.addEventListener("resize", checkPosition);
    window.addEventListener("load", checkPosition);
  }, 1000);
  


});
